<div class="container">
    <ui-page-template [showFooter]="true">
      <div slot="content" class="content">
        <app-payment-in-progress-screen></app-payment-in-progress-screen>
      </div>
    </ui-page-template>
  </div>
  